import { styled } from './stitches.config';

export const Heading = styled('h2', {
	fontFamily: '$baskerville',
	fontSize: '$heading',
	fontWeight: '$reg',
	textTransform: 'uppercase',
});
